import React, { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, FilePdfOutlined } from '@ant-design/icons';
import CommonTable from '../../shared/components/common-table/commonTable';
import CustomDropDown from '../../shared/components/dropdown/customDropDown';
import { Button, message, Skeleton } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { routeConfig } from '../../shared/common/constant';
import { useQueryHook } from '../../shared/hooks/useQueryHook';
import { transformPFi } from '../../shared/hooks/transfromApiData';
import { GetAllPfiList, DeletePFI } from '../../shared/common/graphqlQuery';
import { companyData } from '../../core/auth';
import { useStore } from '../../shared/hooks/stateStore';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import DeleteModal from '../../shared/components/deleteModal/deleteModal';
import cloneDeep from 'lodash/cloneDeep';

let constReason;
let deleteId;
const dropDownButton = {
    name: 'Action '
}

const dropDownElements = [
    {
        key: '0',
        name: 'Edit',
        icon: <EditOutlined />
    },
    {
        key: '1',
        name: 'Delete',
        icon: <DeleteOutlined />
    },
    {
        key: '2',
        name: 'PDF',
        icon: <FilePdfOutlined />
    }
]


const tableConfig = {
    bordered: false,
    loading: false,
    pagination: {
        position: 'bottomRight',
        current: 1,
        pageSize: 10
    },
    showHeader: true,
    tableLayout: undefined,
    descSortKey: 'date'
    // sortDirections: ['ascend' , 'descend','ascend' ]
};
const onError = (error: any, result: any) => {

}
const ProformaList = () => {
    const history = useHistory();
    const onDeletePFI = (result: any) => {
        const constData = cloneDeep(data);
        const deletedIndex = constData.getAllPFIs.findIndex(eachData => eachData['_id'] === deleteId);
        constData.getAllPFIs[deletedIndex].isDeleted = true;
        constData.getAllPFIs[deletedIndex].reasonToDelete = constReason;
        data.getAllPFIs[deletedIndex].isDeleted = true;
        data.getAllPFIs[deletedIndex].reasonToDelete = constReason;
        setPFIListData(transformPFi(data, showDeletedData));
        message.success(result.deletePFI.message);
    }

    const companyId = companyData().getCompanyData();
    const { loading, data, error } = useQueryHook(GetAllPfiList, { companyId });
    const DeletePFIMutation = useMutationHook(DeletePFI, onDeletePFI, onError);
    const [PFIListData, setPFIListData] = useState([]);
    
    const [showDeletedData, setshowDeletedData] = useState<boolean>(false);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

    const dropDownDeletedElements = [
        {
            key: '0',
            name: 'PDF',
            icon: <FilePdfOutlined />
        }
    ]
    const deletedColumns = [
        {
            title: 'Invoice No.',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            sorter: true,
        },
        // {
        //     title: 'Buyer Name',
        //     dataIndex: 'buyerName',
        //     key: 'buyerName',
        //     sorter: true,
        // },
        {
            title: 'Reason',
            dataIndex: 'reasonToDelete',
            key: 'reasonToDelete',
            sorter: true,
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            sorter: true,
            defaultSortOrder: 'descend'
        },
        {
            title: 'Action',
            key: 'action',
            render: (value: any) => (
                <CustomDropDown
                    dropDownButton={dropDownButton}
                    dropDownElements={dropDownDeletedElements}
                    rowId={value.key}
                    onclickMenu={(rowId: any, key: any) => openGoToDropdownLink(rowId, key)}>
                </CustomDropDown>
            ),
        },
    ];
    const changeDateInvoicesFunc = () => {
        setPFIListData(transformPFi(data, !showDeletedData));
        setshowDeletedData(!showDeletedData);
    }
    const showDeleteModalFunc = (setModalVisibility) => {
        setIsModalVisible(setModalVisibility);
        // setIsModalVisible(true);
    }
    const onDelete = (reason) => {
        constReason = reason;
        DeletePFIMutation.callMutation({ variables: { pfiId: deleteId, companyId, reasonToDelete: reason } });
        setIsModalVisible(false);
    }

    useEffect(() => {
        useStore.setState({ pfiData: null });
    }, [])
    useEffect(() => {
        setPFIListData(transformPFi(data, showDeletedData));
    }, [data?.getAllPFIs]);
    const columns = [
        {
            title: 'Invoice No.',
            dataIndex: 'invoiceNumber',
            key: 'invoiceNumber',
            sorter: true,
        },
        {
            title: 'Buyer Name',
            dataIndex: 'buyerName',
            key: 'buyerName',
            sorter: true,
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            sorter: true,
            defaultSortOrder: 'descend'
        },
        {
            title: 'Action',
            key: 'action',
            render: (value: any) => (
                <CustomDropDown
                    dropDownButton={dropDownButton}
                    dropDownElements={dropDownElements}
                    rowId={value.key}
                    onclickMenu={(rowId: any, key: any) => openGoToDropdownLink(rowId, key)}>
                </CustomDropDown>
            ),
        },
    ];
    const openGoToDropdownLink = (key: any, value: any) => {
        let pfiDataIndex;
        if (showDeletedData) {
            pfiDataIndex = data?.getAllPFIs.findIndex(eachPFIData => eachPFIData['_id'] === key);
            if (pfiDataIndex !== -1) {
                useStore.setState({ pfiData: data?.getAllPFIs[pfiDataIndex] });
                history.push('proformaInvoicePdf/' + key);
            }
        } else {
            switch (+value.key) {
                case 0:
                    pfiDataIndex = data?.getAllPFIs.findIndex(eachPFIData => eachPFIData['_id'] === key);
                    if (pfiDataIndex !== -1) {
                        useStore.setState({ pfiData: data?.getAllPFIs[pfiDataIndex] });
                        history.push('proforma/' + key);
                    }
                    break;
                case 1:
                    if (!DeletePFIMutation.loading) {
                        deleteId = key;
                        setIsModalVisible(true);
                        // DeletePFIMutation.callMutation({ variables: { pfiId: key, companyId } });
                    }
                    break;
                case 2:
                    pfiDataIndex = data?.getAllPFIs.findIndex(eachPFIData => eachPFIData['_id'] === key);
                    if (pfiDataIndex !== -1) {
                        useStore.setState({ pfiData: data?.getAllPFIs[pfiDataIndex] });
                        history.push('proformaInvoicePdf/' + key);
                    }
                    break;
            }
        }
    };
    const addInvoiceFunc = () => {
        history.push(routeConfig.proforma.path);
    }
    return (
        <>
            <DeleteModal
                showDeleteModal={isModalVisible}
                modalVisibleFunc={showDeleteModalFunc}
                onSave={onDelete}>
            </DeleteModal>
            {
                loading ? <Skeleton active /> : <CommonTable
                    className="my-component"
                    tableConfig={tableConfig}
                    columns={showDeletedData ? deletedColumns : columns}
                    showDeletedInvoices={showDeletedData}
                    allowDeletedData={true}
                    tableRowdata={PFIListData}
                    addBtnString='Add Proforma Invoice'
                    btnCallFunc={addInvoiceFunc}
                    changeDateInvoices={changeDateInvoicesFunc} />
            }
        </>
    );
}
export default ProformaList